import axios from 'axios';

// Public (no-auth) calls for the prospect-facing trial request page. Uses a bare axios instance
// so the main API client's 401 -> /login redirect never fires for visitors.
const pub = axios.create({ baseURL: '/api/trial-requests/public' });

export const trialPublicService = {
  getTerms: () => pub.get('/terms'),
  submit: (d) => pub.post('/', d),
  resend: (id) => pub.post(`/${id}/resend`),
  verify: (id, code) => pub.post(`/${id}/verify`, { code }),
};
